//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetServiceListResponse } from './models/GetServiceListResponse';
import type { InfoService } from './models/InfoService';
import { Utilities } from './Utilities';

export class InfoServicesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getServiceList: (): string => {
            let clientRequestUrl = '/api/v3/info-services';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getService: (
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v3/info-services/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves the list of all info services.
     * @return OK
     */
    async getServiceList(): Promise<GetServiceListResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getServiceList();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetServiceListResponse>(_response, false, []);
    }

    /**
     * Retrieves a single info service by its identifier.
     * @param id Service key of a service
     * @return OK
     */
    async getService(
        id: string,
    ): Promise<InfoService> {
        const clientRequestUrl = this.baseUrl + this.routes.getService(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<InfoService>(_response, false, []);
    }
}
